var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Polaris-Connected"
  }, [(_vm.$slots.left || _vm.left) ? _c('polaris-connected-item', {
    attrs: {
      "position": "Left"
    }
  }, [_vm._t("left", [_vm._v(_vm._s(_vm.left))])], 2) : _vm._e(), _vm._v(" "), _c('polaris-connected-item', {
    attrs: {
      "position": "Primary"
    }
  }, [(!_vm.$slots.children) ? _vm._t("default", [_vm._v("\n           " + _vm._s(_vm.children) + "\n        ")]) : _vm._e(), _vm._v(" "), _vm._t("children")], 2), _vm._v(" "), (_vm.$slots.right || _vm.right) ? _c('polaris-connected-item', {
    attrs: {
      "position": "Right"
    }
  }, [_vm._t("right", [_vm._v(_vm._s(_vm.right))])], 2) : _vm._e()], 1)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-d561768c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d561768c","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PolarisConnected.vue
// module id = 312
// module chunks = 0